import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  background: ${props => props.theme.white};
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  padding-top: 10px;
  padding-bottom: 12px;
  margin-bottom: 16px;

  .content {
    display: flex;
    gap: 16px;
    margin-top: 8px;
  }

  .stat {
    flex: 1;

    .label {
      font-size: 14px;
      font-weight: 400;
    }

    .value {
      font-weight: 600;
      font-size: 24px;

      .limit {
        font-size: 14px;
        font-weight: 600;
      }
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;

    button {
      margin-top: 0;
    }
  }
`
